import React from 'react'
import animation from "../../assets/Animation - 1701443964112.json"
import Lottie from 'react-lottie';

function Loader() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div className='w-screen h-screen flex flex-col items-center justify-center '>
            <Lottie options={defaultOptions}
                height={400}
                width={400}
            />
        </div>
    )
}

export default Loader